import { TourModule } from "training/types";

/**
 * CLE-3015 — what each module is about: the title and one-sentence purpose the popover shows (the title on
 * every step, both on a module's first step). Titles and purposes are John's (review 1, 2026-10-23).
 *
 * `minutes` is a rough time for the module, shown in the welcome card's outline (Module 1's first step) and
 * read by the module title screens. It comes from a heuristic over the module's steps as they run on a
 * hospital like General Hospital on dev (one branch of each pair, no second-run or failure-only steps), not
 * from timing anyone:
 *   look 15 s · click 20 s · fill 45 s · card / picture 20 s · open-cancel 40 s · a "..." menu opener +20 s,
 *   plus 1 minute in Module 2 for the text to reach the trainee's phone and 2 for reading it there,
 * rounded to the nearest 5 minutes, at least 5. Rough on purpose; John corrects them on his next review.
 */
export const MODULES: Record<
  TourModule,
  { title: string; purpose: string; minutes?: number }
> = {
  1: {
    title: "Navigating the Estimates page",
    purpose:
      "This module will walk you through the Estimates page, the home page everything else starts from.",
    // 13 looks, 2 cards: 3.9 min.
    minutes: 5,
  },
  2: {
    title: "Creating and sending an estimate",
    purpose:
      "This module will walk you through creating a real estimate for yourself and sending it to your own phone.",
    // 13 fills, 3 looks, 3 clicks, 3 cards, plus the phone: 15.5 min.
    minutes: 15,
  },
  3: {
    title: "How to search for and view an estimate",
    purpose:
      "This module will walk you through the basics of how to search for an estimate and what you can do with it once it is created.",
    // 2 fills, 5 looks, 3 clicks, 3 open-cancels, 1 opener: 6.1 min.
    minutes: 5,
  },
  4: {
    title: "How to collect payment",
    purpose: "This module will cover how to collect payment.",
    // 1 fill, 10 looks, 5 clicks, 2 cards, 1 opener: 5.9 min.
    minutes: 5,
  },
  5: {
    title: "Payment plans and refunds",
    purpose:
      "This module will detail how to edit payment plans, refund the patient, and more.",
    // 3 looks, 5 cards, 2 open-cancels, 1 opener: 4.1 min.
    minutes: 5,
  },
  6: {
    title: "Activity timeline, notes and reporting",
    purpose:
      "This module will detail how to make use of the notes section and the activity timeline, as well as how to access reports.",
    // 2 fills, 5 looks, 4 clicks, 2 cards: 4.8 min.
    minutes: 5,
  },
};
